import { createContext } from '@lit/context';
import { Product, ProductOption, Store } from '@repobit/dex-store';
import { stateContextType } from './context.state';

export type Params = {
  product?: Product | null,
  option? : ProductOption | null,
  state?  : stateContextType,
  store?  : Store
};

export type derivedContextType = (param: Params) => Promise<Record<string, unknown>>

export const derivedContext = createContext<derivedContextType | undefined | null>(Symbol('derived'));